// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__AyXIu","focado":"OptionSelect_focado__-kn4m"};